import unblockCancelTripMessagesModule from "./unblockCancelTripMessagesModule"
import unblockCancelTripMessagesView from "./unblockCancelTripMessagesView.html"

unblockCancelTripMessagesModule.config(["$stateProvider", ($stateProvider) => {
    $stateProvider.state("r2.unblockCancelTripMessages", {
        data: {
            pageTitle: "{{'title.r2.unblockCancelTripMessages' | translate}}",
            group: "group.r2.integration.unblock.cancel.trip.messages"
        },
        template: unblockCancelTripMessagesView,
        url: "/integration/unblockCancel-trip",
        controller: "unblockCancelTripMessagesController"
    })
}])